// Versioned pricing shared by the browser and signing service (parity-tested).
const REVIEW_POLICY = "scope-complexity-2026-10-23-v1";
const LEGACY_TRIP_POLICY = "high-plus-ten-percent-ceil-v1";
const SPEC_TRIP_POLICY = "discounted-high-plus-ten-percent-ceil-v2";
const TIERS = [
  {id:1,label:"Simple",percent:100,minimum:2},
  {id:2,label:"Standard",percent:115,minimum:5},
  {id:3,label:"Complex",percent:130,minimum:8},
  {id:4,label:"Major",percent:150,minimum:16},
];
const CATEGORIES = ["unknown","interior_alteration","single_family_new","addition","commercial_interior","townhome_multifamily","commercial_new_shell","mixed_use"];
function validateScope(scope) {
  if (!scope || !CATEGORIES.includes(scope.category) || typeof scope.description !== "string" || scope.description.length>4000
    || !Array.isArray(scope.sources) || scope.sources.length>20
    || scope.sources.some(s=>typeof s?.fileId!=="string" || !s.fileId || s.fileId.length>200 || !Number.isInteger(s.page) || s.page<1)
    || ["buildings","stories","units"].some(k=>scope[k]!==null && (!Number.isInteger(scope[k]) || scope[k]<1 || scope[k]>10000))
    || (scope.areaSqft!==null && (typeof scope.areaSqft!=="number" || !Number.isFinite(scope.areaSqft) || scope.areaSqft<0 || scope.areaSqft>1e9))
    || ["structural","threshold"].some(k=>scope[k]!==null && typeof scope[k]!=="boolean")) throw new Error("Review the plan-review scope facts and page evidence.");
  if (scope.category!=="unknown" && !scope.sources.length) throw new Error("Scope recommendations require page evidence.");
  return scope;
}
function recommendedTier(scope) {
  if (!scope) return null;
  validateScope(scope);
  if (!scope.sources.length) return null;
  if (scope.buildings>1 || scope.category==="mixed_use"
    || (["commercial_interior","commercial_new_shell"].includes(scope.category) && scope.areaSqft>25000)) return 4;
  if (scope.category==="townhome_multifamily") return 3;
  if (scope.category==="commercial_new_shell") return scope.areaSqft===null ? null : 3;
  if (["single_family_new","addition"].includes(scope.category)) return 2;
  if (scope.category==="commercial_interior") return scope.areaSqft===null ? null : 2;
  if (scope.category==="interior_alteration" && scope.structural===false) return 1;
  return null;
}
function reviewHours(pages,tier) {
  if (!Number.isInteger(pages) || pages<1 || pages>10000 || !TIERS.some(t=>t.id===tier)) throw new Error("Select a plan-review complexity tier and valid page count.");
  let hours=0;
  for (const t of TIERS.slice(0,tier)) {
    // Enforce the spec's strict ordering when whole-hour rounding creates a tie.
    hours=Math.max(t.minimum,Math.ceil(pages*t.percent/500),hours+1);
  }
  return hours;
}
function validateReviewComplexity(value,{complete=false}={}) {
  if (!value || typeof value!=="object" || Array.isArray(value) || typeof value.reason!=="string" || value.reason.length>2000
    || (value.tier!==null && !TIERS.some(t=>t.id===value.tier))) throw new Error("Invalid plan-review complexity selection.");
  const recommended=recommendedTier(value.scope);
  if (complete && value.tier===null) throw new Error("Select a plan-review complexity tier.");
  if (complete && value.tier!==recommended && !value.reason.trim()) throw new Error("Explain the plan-review tier selection or override.");
  return recommended;
}
function draftReviewHours(draft,pages) {
  if (draft.reviewPricingPolicy===undefined) return Math.ceil(pages/5);
  if (draft.reviewPricingPolicy!==REVIEW_POLICY) throw new Error("Unsupported plan-review pricing policy.");
  validateReviewComplexity(draft.reviewComplexity,{complete:true});
  return reviewHours(pages,draft.reviewComplexity.tier);
}
function includedTrips(high,policy) {
  if (!Number.isInteger(high) || high<1 || high>25000) throw new Error("Invalid planned trip count.");
  if (policy===LEGACY_TRIP_POLICY) return Math.ceil(high*11/10);
  if (policy===SPEC_TRIP_POLICY) return Math.ceil(high*187/200);
  throw new Error("Unsupported flat-fee trip allowance.");
}
module.exports={REVIEW_POLICY,LEGACY_TRIP_POLICY,SPEC_TRIP_POLICY,TIERS,CATEGORIES,validateScope,recommendedTier,reviewHours,validateReviewComplexity,draftReviewHours,includedTrips};
